import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0763ebe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "camera_item_thumb" }
const _hoisted_2 = { class: "camera_item_desc" }
const _hoisted_3 = { class: "camera_item_info" }


import Thumbnail from '@/components/atoms/Thumbnail'
import Icon from '@/components/atoms/Icon'
import { Camera } from '@/@types/typescript-axios/api'

type PropsType = {
  cameraData: Camera
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraItem',
  props: {
    cameraData: null
  },
  emits: ["showDetailPage"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'showDetailPage', value: Camera): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  cameraData: Camera
};





/**
 * カメラ詳細情報ダイアログを表示
 */
const showDetailPage = () => {
  emit('showDetailPage', props.cameraData)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "camera_item",
    onClick: showDetailPage
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Thumbnail), {
        src: __props.cameraData.thumb_url,
        width: "100%"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(__props.cameraData.camera_name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Icon), {
          type: "room",
          color: "color-dark2",
          size: "8"
        }),
        _createElementVNode("span", null, _toDisplayString(__props.cameraData.location_address), 1)
      ])
    ])
  ]))
}
}

})